import { render, staticRenderFns } from "./ColorFooter.vue?vue&type=template&id=5d89d5a5&scoped=true&"
import script from "./ColorFooter.vue?vue&type=script&lang=js&"
export * from "./ColorFooter.vue?vue&type=script&lang=js&"
import style0 from "./ColorFooter.vue?vue&type=style&index=0&id=5d89d5a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d89d5a5",
  null
  
)

export default component.exports